;(function () {

"use strict";

var SliderView = require('./slider');
var videojs = require('video.js');

window.HELP_IMPROVE_VIDEOJS = false;

var hasShownZoom = false;

var MobileZoomView = Backbone.View.extend({
  initialize: function (opts) {
    // console.log(opts);
    // console.log('init mobile zoom view');
    this.src = opts.src;
    this.render();
  },
  render: function () {
    var $el = $('<div id="mobile-zoom" class="loading" />');
    var $img = $('<img />').attr('src', this.src);
    var $imgWrapper = $('<div class="image-wrapper" />').append($img);
    var $close = $('<button class="close" />');
    var $instructions = $('<span>Pinch To Zoom</span>');

    var self = this;
    $close.on('click', function () {
      $('#PageContainer').show();
      self.$el.remove();
    })

    $el.append($imgWrapper);
    $el.append($close);

    if (!hasShownZoom) {
      $el.append($instructions);
      hasShownZoom = true;
    }

    imagesLoaded($el, function () {
      $el.removeClass('loading');

      setTimeout(function () {
        $instructions.addClass('hidden');
      }, 3000);
    });

    this.$el = $el;

    $('#PageContainer').hide();
    $('body').append($el);
  }
})

var GalleryView = Backbone.View.extend({
  initialize: function () {
    // console.log('init image gallery');

    this.$imgContainer = this.$el.find('div.img');
    this.$img = this.$el.find('.img img.main').first();

    this.src = this.$img.attr('src');
    this.alt = this.$img.attr('alt');

    this.$zoomImg = this.$el.find('.zoom-img');

    imagesLoaded(this.el, _.bind(this.imagesLoaded, this));
    this.start = new Date().getTime();

    var self = this;

    /* Init zoom img if theres no thumbnails. */
    var img = new Image();
    img.onload = function () {
      self.$zoomImg.data('hi-res-width', this.width);
      self.checkZoom(self.$zoomImg);
    }
    img.src = this.$zoomImg.find('img').attr('src');

    this.$el.find('.thumbnails > li > a').each(function () {
      var $this = $(this);
      if ($this.hasClass('video')) {

        var muted = true;

        /* Hack, should be replaced */
        if ($('h1').text() === 'Baby Play Basics Online Course') {
          muted = false;
        }

        self.player = videojs('product-video', {
          controls: false,
          autoplay: false,
          preload: "auto",
          loop: true,
          muted: muted
        });

        // if (window.App.touch) {
        //   self.player.posterImage.show();
        // }

        self.player.on('loadeddata', function () {
          self.videoLoaded = true;
          self.$el.find('.thumbnails .video').parent().removeClass('loading');
        })
      } else {
        var img = new Image();
        img.src = $this.attr('href');

        if ($this.data('hi-res')) {
          // console.log('loading hires image');
          var hires = new Image();
          hires.onload = function () {
            // console.log('image loaded');
            // console.log(this.width);
            // console.log(this.height);
            $this.data('hi-res-width', this.width);
            $this.data('hi-res-height', this.height);
          }
          hires.src = $this.data('hi-res');
        }
      }
    });

    if (window.App.touch) {
      this.$el.on('swiperight', _.bind(this.prev, this));
      this.$el.on('swipeleft', _.bind(this.next, this));
    }
  },
  imagesLoaded: function () {
    var fin = new Date().getTime();
    var spread = fin - this.start;

    // new ThumbnailSliderView({ el: this.$el.find('.thumbnails-wrapper') });
    new SliderView({ el: this.$el.find('.thumbnails-wrapper'), group: 4 });
    this.$el.addClass('active');

    var $small = this.$el.find('img.small');

    if (spread < 100) {
      $small.addClass('fast');
    }

    _.delay(function () {
      $small.addClass('inactive');    
    }, 400);
  },
  disableZoom: function () {
    this.$el.find('.img').removeClass('can-zoom');
    this.canZoom = false;
  },
  checkZoom: function($el) {
    this.disableZoom();

    if ($el.data('hi-res-width') > 1000) {
      this.canZoom = true;
      this.$el.find('.img').addClass('can-zoom');
    }
  },
  swapImage: function (src, alt, $this, isVideo) {
    if (this.loading) { return; }

    if (!this.interacted) {
      this.$el.find('img.small').remove();
      this.interacted = true;
    }

    this.loading = true;
    this.src = src;


    if (isVideo) {
      this.disableZoom();
      this.isVideo = true;

      var $video = this.$el.find('#product-video');

      this.$img.addClass('inactive');
      this.$img = $video.removeClass('inactive');

      this.loading = undefined;

      // if (!window.App.touch) {
        this.player.play();
      // }


      if (this.videoLoaded) {
        $this.removeClass('loading');
      } else {
        $this.addClass('loading');
      }

      $this.addClass('selected');
      $this.siblings().removeClass('selected');

    } else {
      if (this.isVideo) {
        var player = this.player;
  
        player.pause();
        setTimeout(function () {
          player.currentTime(0);
          // if (window.App.touch) {
          //   $('#product-video .vjs-poster').show();
          // }
        }, 401);

        this.isVideo = false;
      }

      var $img = this.$el.find('img.inactive').first();

      $img.attr('src', src);
      $img.attr('alt', alt);
      $this.addClass('loading');

      this.$zoomImg.find('img').attr('src', $this.find('a').data('hi-res'));

      imagesLoaded($img, _.bind(function () {
        this.loading = undefined;

        this.$img.addClass('inactive');
        this.$img = $img.removeClass('inactive');

        $this.siblings().removeClass('selected');
        $this.removeClass('loading').addClass("selected");

        this.checkZoom($this.find('a'));
      }, this));
    }
  },
  next: function () {
    this.$el.find('li.selected').next().trigger('click');
  },
  prev: function () {
    this.$el.find('li.selected').prev().trigger('click');
  },
  toggleImage: function (e) {
    var $this = $(e.currentTarget);
    
    var src = $this.find('a').attr('href');
    var alt = $this.find('img').attr('alt');
    var isVideo = $this.find('a').hasClass('video');

    if (this.src === src) { return false; }

    this.swapImage(src, alt, $this, isVideo);

    return false;
  },
  adjustZoomPosition: function(e) {
    var zoom = parseFloat($('html').css('zoom')) || 1;
    zoom = parseFloat(zoom);

    var x = parseInt(e.pageX/zoom);
    var y = parseInt(e.pageY/zoom);

    var l = parseInt(this.$imgContainer.offset().left);
    var t = parseInt(this.$imgContainer.offset().top);

    var w = parseInt(this.$imgContainer.innerWidth());
    var h = parseInt(this.$imgContainer.innerHeight());

    var percX = (x - l) / w;
    var percY = (y - t) / h;

    if (percX <= 0) { percX = .001; }
    if (percX >= 1) { percX = .999; }

    if (percY <= 0) { percY = .001; }
    if (percY >= 1) { percY = .999; }

    var imgHeight = parseInt(this.$zoomImg.find('img')[0].height);
    var imgWidth = parseInt(this.$zoomImg.find('img')[0].width);

    var ty = parseInt(percY * (imgHeight - h));
    var tx = parseInt(percX * (imgWidth - w));

    var translate = 'translateY(-'+ty+'px) translateX(-'+tx+'px)';

    this.$zoomImg.find('img').first().css({
      'transform': translate,
    });
  },
  events: {
    'click #product-video': function (e) {
      if (this.player && !window.App.touch) {
        if (this.player.paused()) {
          this.player.play();
          // $('#product-video .vjs-poster').hide();
        } else {
          this.player.pause();
        }
      }
      return false;
    },
    'touchstart #product-video': function (e) {
      if (this.player) {
        if (this.player.paused()) {
          this.player.play();
          // $('#product-video .vjs-poster').hide();
        } else {
          this.player.pause();
        }
      }
    },
    'click .thumbnails > li': 'toggleImage',
    'click div.img-container': function (e) {
      if (window.App.touch) {
        console.log('touch path');

        $("#mobile-zoom").remove();
        new MobileZoomView({ src: this.$zoomImg.find('img').attr('src') });

        return;
      }

      if (!this.canZoom) { return; }

      // console.log('clicked on img');
      if (this.enableZoom) {
        this.enableZoom = false;
        this.$zoomImg.removeClass('active');
      } else {
        this.enableZoom = true;
        this.adjustZoomPosition(e);
        this.$zoomImg.addClass('active');
      }
    },
    'mouseleave div.img-container': function(e) {
      if (window.App.touch || !this.canZoom) { return; }

      if (this.enableZoom) {
        // console.log('mouseout on img');
        this.enableZoom = false;
        this.$zoomImg.removeClass('active');
      }
    },
    'mousemove div.img-container': function(e) {
      if (window.App.touch || !this.canZoom) { return; }

      if (this.enableZoom) {
        // console.log('moving in img here');
        this.adjustZoomPosition(e);
      }
    }
  }
});

module.exports = GalleryView;

}());